import { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Paper, Box, Typography } from "@mui/material";


const ChatHistory = ({ messages }) => {
    const messagesEndRef = useRef(null);

    // Auto-scroll to bottom when messages change
    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages]);

    return (
        <Paper sx={{ flexGrow: 1, height: "calc(80vh - 150px)", overflowY: "auto", mb: 2, p: 2 }}>
            {messages.map((msg, index) => (
                <Box
                    key={index}
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: msg.is_client === false ? "flex-end" : "flex-start",
                        mb: 1,
                    }}
                >
                    <Typography
                        variant="body2"
                        sx={{
                            backgroundColor: msg.is_client === false ? "info.main" : "grey.300",
                            color: msg.is_client === false ? "white" : "black",
                            borderRadius: 2,
                            p: 1,
                            maxWidth: "70%",
                        }}
                    >
                        {msg.message}
                    </Typography>
                    <Typography variant="caption" sx={{ color: "gray", mt: 0.5 }}>
                        {msg.time}
                    </Typography>
                </Box>
            ))}
            
            {/* Dummy element to scroll into view */}
            <div ref={messagesEndRef} />
        </Paper>
    );
};

ChatHistory.propTypes = {
    messages: PropTypes.arrayOf(
        PropTypes.shape({
            message: PropTypes.string.isRequired,
            time: PropTypes.string.isRequired,
            is_client: PropTypes.bool.isRequired,
        })
    ).isRequired,
};

export default ChatHistory;